module.exports = {"title":"ShowTix4U Order Reprint","description":"Please enter your email and previous orders will be sent to you:","email":"Email","send":"Send","success":"Thank you, an email is on the way!","error":"Sorry, but your email doesn't exist in our databases. Please contact tickets@showtix4u.com","errorRequired":"This field is required.","errorInvalid":"The format is invalid.","msg":{"yay":"Yay!","oops":"Oops!","success":"Orders have been resent successfully."}}


//////////////////
// WEBPACK FOOTER
// ./src/components/ReprintOrder/locales/en.json
// module id = 1378
// module chunks = 0